import React from 'react';
import { Icon } from '../icon/icon';
import './completion-container.scss';
export var CompletionContainer = function (_a) {
    var children = _a.children, heading = _a.heading, text = _a.text, icon = _a.icon, status = _a.status;
    return (React.createElement("section", { className: "c-completion-container ".concat(status !== null && status !== void 0 ? status : '') },
        React.createElement("div", { className: "c-completion-container__body" },
            icon && (React.createElement("span", { className: "c-completion-container__body__icon  ".concat(status !== null && status !== void 0 ? status : '') },
                React.createElement(Icon, { name: icon, size: "large" }))),
            React.createElement("h2", { className: "u-mb-3" }, heading),
            React.createElement("p", null, text)),
        React.createElement("div", { className: "c-completion-container__footer" }, children)));
};
